/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetBrands200ResponseInner,
  GetIsBrandDeletable200Response,
} from '../models/index';
import {
    GetBrands200ResponseInnerFromJSON,
    GetBrands200ResponseInnerToJSON,
    GetIsBrandDeletable200ResponseFromJSON,
    GetIsBrandDeletable200ResponseToJSON,
} from '../models/index';

export interface DeleteBrandRequest {
    brandId: string;
}

export interface GetIsBrandDeletableRequest {
    brandId: string;
}

/**
 * 
 */
export class BrandsApi extends runtime.BaseAPI {

    /**
     */
    async deleteBrandRaw(requestParameters: DeleteBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError(
                'brandId',
                'Required parameter "brandId" was null or undefined when calling deleteBrand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/brands/{brandId}`.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteBrand(requestParameters: DeleteBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBrandRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getBrandsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetBrands200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/brands/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetBrands200ResponseInnerFromJSON));
    }

    /**
     */
    async getBrands(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetBrands200ResponseInner>> {
        const response = await this.getBrandsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getIsBrandDeletableRaw(requestParameters: GetIsBrandDeletableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIsBrandDeletable200Response>> {
        if (requestParameters['brandId'] == null) {
            throw new runtime.RequiredError(
                'brandId',
                'Required parameter "brandId" was null or undefined when calling getIsBrandDeletable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/brands/deletable/{brandId}`.replace(`{${"brandId"}}`, encodeURIComponent(String(requestParameters['brandId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIsBrandDeletable200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getIsBrandDeletable(requestParameters: GetIsBrandDeletableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIsBrandDeletable200Response> {
        const response = await this.getIsBrandDeletableRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
